var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAssignInstructor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1664_310)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.3334 16.75V15.9167C13.3334 15.4746 13.1578 15.0507 12.8452 14.7382C12.5326 14.4256 12.1087 14.25 11.6667 14.25H8.33335C7.89133 14.25 7.4674 14.4256 7.15484 14.7382C6.84228 15.0507 6.66669 15.4746 6.66669 15.9167V16.75",
    stroke: "#1D7777",
    strokeWidth: 1.06465,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.99998 12.5833C10.9205 12.5833 11.6666 11.8371 11.6666 10.9167C11.6666 9.99619 10.9205 9.25 9.99998 9.25C9.07951 9.25 8.33331 9.99619 8.33331 10.9167C8.33331 11.8371 9.07951 12.5833 9.99998 12.5833Z",
    stroke: "#1D7777",
    strokeWidth: 1.06465,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1664_310)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.36193 8.36193L1.39203 6.39203",
    stroke: "#1D7777",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.3619 6.39199H1.392V8.36189",
    stroke: "#1D7777",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_1664_310)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.392 8.36193L18.3619 6.39203",
    stroke: "#1D7777",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.392 6.39199H18.3619V8.36189",
    stroke: "#1D7777",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_1664_310)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.995 13.3879L18.7808 13.3879",
    stroke: "#1D7777",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3879 11.9949L18.7808 13.3879L17.3879 14.7808",
    stroke: "#1D7777",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4_1664_310)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.78079 13.3879L0.994934 13.3879",
    stroke: "#1D7777",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.38786 14.7808L0.994934 13.3879L2.38786 11.995",
    stroke: "#1D7777",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip5_1664_310)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.3879 6.78079V3.99493",
    stroke: "#1D7777",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.99493 5.38786L10.3879 3.99493L11.7808 5.38786",
    stroke: "#1D7777",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1664_310"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1664_310"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4.77576,
    height: 4.77576,
    fill: "white",
    transform: "matrix(-0.707107 0.707107 0.707107 0.707107 2.37695 4)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_1664_310"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4.77576,
    height: 4.77576,
    fill: "white",
    transform: "translate(17.377 4) rotate(45)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_1664_310"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4.77576,
    height: 4.77576,
    fill: "white",
    transform: "translate(19.7758 11) rotate(90)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4_1664_310"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4.77576,
    height: 4.77576,
    fill: "white",
    transform: "translate(0 15.7758) rotate(-90)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip5_1664_310"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4.77576,
    height: 4.77576,
    fill: "white",
    transform: "translate(8 3)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssignInstructor);
export default __webpack_public_path__ + "static/media/AssignInstructor.12acfa23b288bbf9ed9063bbb3760db0.svg";
export { ForwardRef as ReactComponent };